if (!customElements.get('ugc-video-tile')) {
  class UgcVideoTile extends HTMLElement {
    connectedCallback() {
      this.addEventListener(
        'click',
        (e) => {
          const trigger = e.target.closest('[data-ugc-video-play]');
          if (!trigger) return;

          const template = this.querySelector('[data-ugc-video-source]');
          if (!template) return;

          trigger.remove();
          this.appendChild(template.content.cloneNode(true));

          this.querySelector('video')?.play().catch(() => {});
        },
        { once: true }
      );
    }
  }

  customElements.define('ugc-video-tile', UgcVideoTile);
}
